export const sessionStorageVariables = {
  TABLE_TYPE: "ccs/eligibility/TABLE_TYPE",
};
